import { type Static, Type } from '@sinclair/typebox';
import { ArangoMetadataSchema } from './arango-metadata';
import { NullableSchema } from './common.js';
import { ProductMetricSchema, ProductSchema } from './product.js';

export const TopSwapStatusSchema = Type.Union([
  Type.Literal('implemented'),
  Type.Literal('new'),
  Type.Literal('under_review'),
  Type.Literal('discarded_never_feasible'),
  Type.Literal('discarded_currently_not_feasible'),
]);
export type TopSwapStatus = Static<typeof TopSwapStatusSchema>;

export const TopSwapInfoSchema = Type.Composite(
  [
    ArangoMetadataSchema,
    Type.Object({
      comment: Type.String(),
      reasons: Type.Array(Type.String()),
      score: NullableSchema(Type.Number()),
      similarity: Type.Number(),
      status: TopSwapStatusSchema,
      swap_metrics: Type.Array(ProductMetricSchema),
    }),
  ],
  { additionalProperties: false },
);
export type TopSwapInfoDTO = Static<typeof TopSwapInfoSchema>;

export const TopSwapSchema = Type.Object({
  prod_details: Type.Pick(ProductSchema, [
    '_key',
    'attributes',
    'item_description_local_language',
    'supplier_item_code',
    'taxons',
  ]),
  option_details: Type.Pick(ProductSchema, [
    '_key',
    'attributes',
    'item_description_local_language',
    'supplier_item_code',
    'taxons',
  ]),
  swap: TopSwapInfoSchema,
});
export type TopSwapDTO = Static<typeof TopSwapSchema>;

// =====================================================================================================================
// List Top Swaps
// =====================================================================================================================

export const ListTopSwapsQuerySchema = Type.Object({
  filter: Type.Union([Type.Literal('SAME_SUPPLIER'), Type.Literal('GLOBAL')]),
});
export type ListTopSwapsQuery = Static<typeof ListTopSwapsQuerySchema>;

export const ListTopSwapsResponseSchema = Type.Array(TopSwapSchema);
export type ListTopSwapsResponse = Static<typeof ListTopSwapsResponseSchema>;

// =====================================================================================================================
// Set Top Swap status
// =====================================================================================================================

export const SetTopSwapStatusBodySchema = Type.Object({
  comment: Type.Optional(Type.String()),
  reasons: Type.Optional(Type.Array(Type.String())),
  status: TopSwapStatusSchema,
});
export type SetTopSwapStatusBody = Static<typeof SetTopSwapStatusBodySchema>;
